.root {
  min-width: 5.4375rem;
  border-radius: 1.5rem;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 1.5rem !important;

  &[data-variant='primary'] {
    background: var(--mantine-color-primary-7);
    color: var(--mantine-color-otherWhite-0);

    &:hover,
    &:active {
      background: var(--mantine-color-primary-9);
    }

    &:disabled {
      background: var(--mantine-color-tertiary-0);
      color: var(--mantine-color-tertiary-2);
    }
  }

  &[data-variant='secondary'] {
    background: var(--mantine-color-secondary-7);

    &:hover,
    &:active {
      background: var(--mantine-color-secondary-9);
    }

    &:disabled {
      background: var(--mantine-color-tertiary-0);
      color: var(--mantine-color-tertiary-2);
    }
  }

  &[data-variant='gray'] {
    background: var(--mantine-color-primary-0);
    color: var(--mantine-color-primary-7);

    &:hover,
    &:active {
      background: var(--mantine-color-primary-2);
      color: var(--mantine-color-primary-7);
    }

    &:disabled {
      background: var(--mantine-color-tertiary-0);
      color: var(--mantine-color-tertiary-2);
    }
  }

  &[data-variant='outline'] {
    background: transparent;
    border: 1px solid var(--mantine-color-primary-7);
    color: var(--mantine-color-primary-7);

    &:hover,
    &:active {
      background: transparent;
      border: 1px solid var(--mantine-color-primary-7);
      color: var(--mantine-color-primary-7);
    }

    &:disabled {
      border: 1px solid var(--mantine-color-primary-0);
      background: transparent;
      color: var(--mantine-color-tertiary-2);
    }
  }

  &[data-variant='subtle'] {
    background: transparent;
    border: none;
    color: var(--mantine-color-secondary-7);

    &:hover,
    &:active {
      background: transparent;
      border: none;
      color: var(--mantine-color-secondary-9);
    }

    &:disabled {
      background: transparent;
      border: none;
      color: var(--mantine-color-tertiary-2);
    }
  }

  &[data-variant='filled'] {
    background: var(--mantine-color-otherWhite-0);
    color: var(--mantine-color-primary-9);

    &:hover,
    &:active {
      background: var(--mantine-color-primary-2);
      color: var(--mantine-color-primary-9);
    }

    &:disabled {
      background: var(--mantine-color-primary-9);
      color: var(--mantine-color-primary-7);
    }
  }

  &[data-variant='unstyled'] {
    background: transparent;
    border: none;
    color: var(--mantine-color-primary-7);

    &:hover,
    &:active {
      background: transparent;
      border: none;
    }

    &:disabled {
      background: transparent;
      border: none;
    }
  }
}
